import { render } from "./PaymentView.vue?vue&type=template&id=bc1bc752&ts=true"
import script from "./PaymentView.vue?vue&type=script&lang=ts"
export * from "./PaymentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__